/* BLENIN quick add on product cards (Balik 4, restyled 2026-09-25 "quickadd2"). Markup: snippets/blenin-quick-add.liquid
   Desktop-only strip (CSS hides it on touch/mobile). Adds with the same request as the theme's product form
   (cart/add.js + sections), refreshes the header cart count and the cart drawer, then opens the drawer. */
(function () {
  if (window.blQuickAdd) return;
  window.blQuickAdd = true;

  function sectionsToUpdate() {
    return ['page-header', 'cart-drawer'].map(function (s) { return document.querySelector(s); })
      .filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
  }

  function addVariant(id, btn, qa) {
    if (!id || (btn && btn.classList.contains('is-loading'))) return;
    var msg = qa && qa.querySelector('.bl-qa__msg');
    if (msg) msg.textContent = '';
    if (btn) btn.classList.add('is-loading');
    var els = sectionsToUpdate();
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    fd.append('sections_url', window.location.pathname);
    fd.append('sections', els.map(function (el) { return el.dataset.sectionId; }).join(','));
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        var data = res.data || {};
        if (!res.ok || data.status) {
          throw new Error(typeof data.description === 'string' ? data.description : (data.message || 'Could not add to bag. Please try again.'));
        }
        if (document.querySelector('.template-cart')) {
          window.location.reload();
          return;
        }
        els.forEach(function (el) {
          if (data.sections && data.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          }
        });
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1200); }
        var drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else if (!drawer) window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id || data.id } }));
      })
      .catch(function (err) {
        if (msg) {
          msg.textContent = err.message;
          setTimeout(function () { msg.textContent = ''; }, 4000);
        }
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  // Right-edge fade while a long size row (shoes) can still scroll.
  function updateScroll(row) {
    var can = row.scrollWidth > row.clientWidth + 1;
    row.classList.toggle('is-scrollable', can);
    row.classList.toggle('is-end', can && row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
  }

  // Multi-colour cards: show the size row of the colour the shopper points at in the card swatches.
  function showColor(block, value) {
    var qa = block && block.querySelector('[data-bl-qa]');
    if (!qa || !value) return;
    var rows = qa.querySelectorAll('.bl-qa__sizes[data-color]');
    if (!rows.length) return;
    value = String(value).toLowerCase().trim();
    var match = null;
    rows.forEach(function (r) { if (r.dataset.color === value) match = r; });
    if (!match) return;
    rows.forEach(function (r) { r.hidden = r !== match; });
    updateScroll(match);
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var row = t.closest('.bl-qa__sizes');
    if (row) { updateScroll(row); return; }
    var item = t.closest('.product-block-options--swatch .product-block-options__item');
    if (item) showColor(item.closest('.product-block'), item.getAttribute('data-option-item'));
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('bl-qa__sizes')) updateScroll(t);
  }, true);

  // Vertical mouse wheel scrolls a long size row sideways.
  document.addEventListener('wheel', function (e) {
    var row = e.target.closest && e.target.closest('.bl-qa__sizes');
    if (!row || row.scrollWidth <= row.clientWidth || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    var max = row.scrollWidth - row.clientWidth;
    if ((e.deltaY > 0 && row.scrollLeft >= max - 1) || (e.deltaY < 0 && row.scrollLeft <= 0)) return; // at the end: let the page scroll
    e.preventDefault();
    row.scrollLeft += e.deltaY;
  }, { passive: false });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var qa = t.closest('[data-bl-qa]');
    if (!qa) return;
    e.preventDefault(); e.stopPropagation();
    var btn = t.closest('.bl-qa__size:not([disabled]), .bl-qa__add');
    if (btn) addVariant(btn.dataset.id, btn, qa);
  }, true);

  // Colour cards (2026-09-26): the card links to ?variant=<first available size of its colour>. Remember the click, so the
  // product page keeps only the colour selected and leaves the size empty (script at the end of sections/main-product.liquid).
  function rememberColourCard(e) {
    var a = e.target && e.target.closest && e.target.closest('product-block[data-bl-color] a.product-link[href]');
    if (!a) return;
    var m = /[?&]variant=(\d+)/.exec(a.getAttribute('href'));
    if (!m) return;
    try { sessionStorage.setItem('bl_cc', JSON.stringify({ v: m[1], t: Date.now() })); } catch (err) { /* storage blocked: the size stays preselected */ }
  }
  document.addEventListener('click', rememberColourCard, true);
  document.addEventListener('auxclick', rememberColourCard, true);
})();
